import { BulkResizeState } from "../../../types";

interface IPayload {
    payload: {
        value: number;
        imageId: string;
    };
}

export const setStraighten = (state: BulkResizeState, { payload: { value, imageId } }: IPayload) => {
    const image = state.images.find((image) => image.id === imageId);
    if (!image) throw new Error("image not found");
    image.rotate.straighten = value;
};
